import UiListItem from "./UiListItem";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import { EnumParamAuditStatus, EnumParamAuditStatusOption } from "./EnumParamAuditStatus";

/**
 * 国际贸易运输方式分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class DtoListItemContactTransportMode extends UiListItem<string> {
    constructor() {
        //无参构造函数
        super()
        this.Status = EnumParamAuditStatus.Not;
        this.IsEdit = false;
    }

    [proName: string]: any;
    /**
     * 中文名称
     */
    Name?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 审核状态
     */
    Status?: EnumParamAuditStatus;
    /**
     * 是否可以编辑
     */
    IsEdit?: boolean;
    /**
     * 创建人所属公司
     */
    CreatedCompanyId?: string;
}

/**
 * 国际贸易运输方式分页列表-项-表单校验
 */
export const DtoListItemContactTransportModeRules = {
}

/**
 * 国际贸易运输方式分页列表-项-设置项
 */
export const DtoListItemContactTransportModeMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "Name",
    Label: "中文名称",
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
  },
  {
    Prop: "FullName",
    Label: "全名",
  },
]
